"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firebase = exports.db = exports.cloudStorage = exports.auth = void 0;
exports.firestoreCacheKey = firestoreCacheKey;
exports.memorySeriesDB = exports.memoryResourcesDB = exports.memoryModulesDB = void 0;
exports.useAuth = useAuth;
exports.useDownloadUrl = useDownloadUrl;
exports.useDownloadUrls = useDownloadUrls;
exports.useFirestoreData = useFirestoreData;
exports.useFirestoreVariableCollection = useFirestoreVariableCollection;
exports.useFirestoreVariableDoc = useFirestoreVariableDoc;
exports.useMemoryDB = useMemoryDB;
exports.useMemoryPower = useMemoryPower;
exports.useOnlineStatus = useOnlineStatus;

var _app = require("firebase/app");

var _firestore = require("firebase/firestore");

var _auth = require("firebase/auth");

var _react = require("react");

var _storage = require("firebase/storage");

function _readOnlyError(name) { throw new TypeError("\"" + name + "\" is read-only"); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Config data is imported from .env files, to allow for development to use a testing server
var firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG); // Initialize Firebase

var firebase = (0, _app.initializeApp)(firebaseConfig);
exports.firebase = firebase;
var auth = (0, _auth.getAuth)(firebase);
exports.auth = auth;
var db = (0, _firestore.getFirestore)(firebase);
exports.db = db;
var cloudStorage = (0, _storage.getStorage)(firebase); // enable firestore to be accessible offline

exports.cloudStorage = cloudStorage;
(0, _firestore.enableIndexedDbPersistence)(db).catch(function (err) {
  if (err.code == 'failed-precondition') {
    console.log("Multiple tabs open, firestore persistence can only be enabled in one tab at a a time.");
  } else if (err.code == 'unimplemented') {
    console.log("The current browser does not support all of the features required to enable firestore persistence.");
  }
}); // enable auth persistence

(0, _auth.setPersistence)(auth, _auth.indexedDBLocalPersistence).catch(console.error);

function useOnlineStatus() {
  var _useState = (0, _react.useState)(navigator.onLine),
      _useState2 = _slicedToArray(_useState, 2),
      online = _useState2[0],
      setOnline = _useState2[1]; // Listen to online state


  (0, _react.useEffect)(function () {
    var f = function f() {
      return setOnline(navigator.onLine);
    };

    window.addEventListener("online", f);
    window.addEventListener("offline", f);
    return function () {
      window.removeEventListener("online", f);
      window.removeEventListener("offline", f);
    };
  }, []);
  return online;
}
/**
 * @returns a fresh reference to the current user, taking user.profile from firestore
 */


function useAuth() {
  var _useState3 = (0, _react.useState)(auth.currentUser),
      _useState4 = _slicedToArray(_useState3, 2),
      user = _useState4[0],
      setUser = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      token = _useState6[0],
      setToken = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      profile = _useState8[0],
      setProfile = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      freshClaims = _useState10[0],
      setFreshClaims = _useState10[1];

  var online = useOnlineStatus(); // Listen to onAuthStateChanged

  (0, _react.useEffect)(function () {
    var unsubProfile = function unsubProfile() {
      return null;
    };

    var unsubAuth = auth.onAuthStateChanged( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(newUser) {
        var profileDocRef;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (newUser) {
                  // get firestore profile ()
                  profileDocRef = (0, _firestore.doc)(db, 'users', newUser.uid);
                  unsubProfile();
                  unsubProfile = (0, _firestore.onSnapshot)(profileDocRef, /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(snap) {
                      var newProfile;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              newProfile = snap.data();
                              if (!snap.exists()) console.error("\n            This user's profile does not exist. There may be an inconsistent local firebase state.\n            Try Clear-Refresh-Clear with clearing the website data (Firebase's IndexedDB).\n          "); // console.log({snap, exists: snap.exists(), data: newProfile })

                              setProfile(newProfile); // get updated claims token ()

                              if (!token) {
                                if (online && !freshClaims) {
                                  // force new claims once
                                  newUser.getIdTokenResult(true).then(setToken).catch(console.error);
                                  setFreshClaims(true);
                                } else {
                                  // otherwise trust the latest token
                                  newUser.getIdTokenResult(false).then(setToken).catch(console.error);
                                }
                              }

                            case 4:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }(), console.error);
                  setUser(newUser);
                } else {
                  setProfile(null);
                  setUser(null);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), console.error);
    return function () {
      unsubProfile();
      unsubAuth();
    };
  }, [online]);
  return user && _objectSpread(_objectSpread(_objectSpread({}, user), token), {}, {
    profile: profile,
    online: online
  });
}
/**
 * @returns the url to download an cloud storage file at @param storageLocation
 */


function useDownloadUrl(storageLocation) {
  var _useState11 = (0, _react.useState)(),
      _useState12 = _slicedToArray(_useState11, 2),
      url = _useState12[0],
      setUrl = _useState12[1];

  (0, _react.useEffect)(function () {
    if (storageLocation) (0, _storage.getDownloadURL)((0, _storage.ref)(cloudStorage, storageLocation)).then(function (url) {
      return setUrl(url);
    });else setUrl(undefined);
  }, [storageLocation]);
  return url;
}

function firestoreCacheKey(storageLocation) {
  var r = (0, _storage.ref)(cloudStorage, storageLocation);
  return storageLocation && "https://firebasestorage.googleapis.com/v0/b/".concat(r.bucket, "/o/").concat(encodeURIComponent(r.fullPath), "?alt=media");
}

function useDownloadUrls(storageLocations) {
  var _useState13 = (0, _react.useState)([]),
      _useState14 = _slicedToArray(_useState13, 2),
      urls = _useState14[0],
      setUrls = _useState14[1];

  (0, _react.useEffect)(function () {
    if (!storageLocations) return;
    var urls = Array(storageLocations.length);
    Promise.all(storageLocations.map(function (location, i) {
      return location && (0, _storage.getDownloadURL)((0, _storage.ref)(cloudStorage, location));
    } //.then(url => urls[i]=url)
    )).then(setUrls);
  }, [storageLocations]);
  return urls;
}
/**
 * A shortcut to the user's memory power from user.profile.power
 * @returns a user's memory power
 */


function useMemoryPower() {
  // shortcut to the memory power
  var user = useAuth();
  return user.profile.power;
}

var memoryResourcesDB = 'memoryResources';
exports.memoryResourcesDB = memoryResourcesDB;
var memorySeriesDB = 'memorySeries';
exports.memorySeriesDB = memorySeriesDB;
var memoryModulesDB = 'memoryModules';
/**
 * @returns the database of memory videos which are available
 */

exports.memoryModulesDB = memoryModulesDB;

function useMemoryDB() {
  var resources = useFirestoreData((0, _firestore.collection)(db, memoryResourcesDB));
  var modules = useFirestoreData((0, _firestore.collection)(db, memoryModulesDB));
  var seriesList = useFirestoreData((0, _firestore.collection)(db, memorySeriesDB));
  return {
    resources: resources,
    modules: modules,
    seriesList: seriesList
  };
}
/**
 * @returns the database of memory videos which are available
 */


function useFirestoreData(q) {
  var fromCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState15 = (0, _react.useState)({}),
      _useState16 = _slicedToArray(_useState15, 2),
      values = _useState16[0],
      setValues = _useState16[1];

  (0, _react.useEffect)(function () {
    if (fromCache) {
      // optionally get data from cache
      if (q.type === "document") (0, _firestore.getDocFromCache)(q).then(function (d) {
        return setValues(d.data());
      });else (0, _firestore.getDocsFromCache)(q).then(function (snap) {
        data = {};
        snap.forEach(function (d) {
          data[d.id] = d.data();
        });
        setValues(data);
      });
    } else {
      // not fromCache
      var unsub = (0, _firestore.onSnapshot)(q, function (snap) {
        var data = {};
        if (q.type === "document") data = snap.data();else snap.forEach(function (d) {
          data[d.id] = d.data();
        });
        setValues(data);
      });
      return unsub;
    }
  }, []);
  return values;
}

function useFirestoreVariableDoc(d) {
  var fromCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState17 = (0, _react.useState)({}),
      _useState18 = _slicedToArray(_useState17, 2),
      valuesState = _useState18[0],
      setValues = _useState18[1];

  var values = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!d) return;
    var query = (0, _firestore.doc)(db, d);
    if (fromCache) // optionally get data from cache
      (0, _firestore.getDocFromCache)(query).then(function (d) {
        return setValues(values.current = d.data());
      });else // not fromCache
      return (0, _firestore.onSnapshot)(query, function (d) {
        return setValues(values.current = d.data());
      });
  }, [d]);
  return [valuesState, values];
}

function useFirestoreVariableCollection(c) {
  var fromCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState19 = (0, _react.useState)({}),
      _useState20 = _slicedToArray(_useState19, 2),
      valuesState = _useState20[0],
      setValues = _useState20[1];

  var values = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!c) return;
    var query = (0, _firestore.collection)(db, c);

    var processData = function processData(snap) {
      data = {};
      snap.forEach(function (d) {
        data[d.id] = d.data();
      });
      setValues((data, _readOnlyError("values")));
    }; // optionally get data from cache


    if (fromCache) (0, _firestore.getDocsFromCache)(query).then(processData);else return (0, _firestore.onSnapshot)(query, processData);
  }, [c]);
  return [valuesState, values];
}